// extracted by css-extract-rspack-plugin
export default {"root":"root-sZPSUO text-base","compact":"compact-Cr08w6","header":"header-iTQCiE","label":"label-nDqwGX text-xl-semibold"};